import {SizeContextSizeValue} from '@packages/utilities/styled';
import {
  DIVIDER_HEIGHT,
  MEDIUM_DIVIDER_MARGIN,
  X_LARGE_DIVIDER_MARGIN,
  MEDIUM_AUTOCOMPLETE_OPTION_HEIGHT,
  X_LARGE_AUTOCOMPLETE_OPTION_HEIGHT,
  MEDIUM_AUTOCOMPLETE_LISTBOX_PADDING,
  X_LARGE_AUTOCOMPLETE_LISTBOX_PADDING,
} from './_consts';

export const getDividerHeight = (size: SizeContextSizeValue) => {
  if (size === 'x-large') {
    return X_LARGE_DIVIDER_MARGIN * 2 + DIVIDER_HEIGHT;
  } else {
    return MEDIUM_DIVIDER_MARGIN * 2 + DIVIDER_HEIGHT;
  }
};

export const getOptionHeight = (size: SizeContextSizeValue) => {
  if (size === 'x-large') {
    return X_LARGE_AUTOCOMPLETE_OPTION_HEIGHT;
  } else {
    return MEDIUM_AUTOCOMPLETE_OPTION_HEIGHT;
  }
};

export const getListBoxPadding = (size: SizeContextSizeValue) => {
  if (size === 'x-large') {
    return X_LARGE_AUTOCOMPLETE_LISTBOX_PADDING;
  } else {
    return MEDIUM_AUTOCOMPLETE_LISTBOX_PADDING;
  }
};
